import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

type Props = {
  tabsInitialState: Array<{ title: string; index: number; active: boolean; dataTestId: string }>;
};

export const useTabs = ({ tabsInitialState }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParams = searchParams.get('tab');

  const [tabs, setTabs] = useState(tabsInitialState);

  const setOpenTab = useCallback(
    (index: number) => {
      setTabs([...tabs.map(tab => ({ ...tab, active: tab.index === index }))]);
      setSearchParams(
        prev => {
          const params = new URLSearchParams(prev);
          params.set('tab', tabs[index].dataTestId);
          return params;
        },
        { replace: true },
      );
    },
    [setSearchParams, tabs],
  );

  useEffect(() => {
    if (tabParams) {
      const tabIndex = tabs.findIndex(tab => tab.dataTestId === tabParams);
      if (tabIndex !== -1) {
        setOpenTab(tabIndex);
      }
    } else {
      setOpenTab(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabParams]);

  return {
    tabParams,
    setOpenTab,
    tabs,
  };
};
